

import { get, post,put,destroy } from "./base";

 const AddProductFeedback = {
  index: (params) => get("/product-feedbacks", { params }),
  single: (id) => get(`/product-feedbacks/${id}`),
  create: (payload) => post("/product-feedbacks", payload),
  update: (id, payload) => put(`/product-feedbacks/${id}`, payload),
  remove: (id) => destroy(`/product-feedbacks/${id}`),


};

export default AddProductFeedback;
